export default {
  title: 'Boekingsmeldingen',
  label: 'Naar welk adres moeten we meldingen van reserveringen sturen?',
  placeholder: 'bijv. reserveringen@uwrestaurant.nl',
  helper:
    'Elk e-mailadres werkt — er is geen toegang tot het dashboard nodig. U kunt het later wijzigen of meer adressen toevoegen in Reserveringen → Instellingen → Meldingen & Bevestiging.',
  errors: {
    required: 'Voeg een e-mailadres toe om boekingsmeldingen te ontvangen.',
    invalid: 'Voer een geldig e-mailadres in, zoals naam@restaurant.nl.',
  },
};
